import React from "react";
import Header from "../../../sharedScreens/Header";
import SideMenu from "../../../sharedScreens/menuItems/SideMenu";
import { MuiDropDown } from "../../../components/basicComponent/MuiDropDown";
import MuiButton from "../../../components/basicComponent/MuiButton";
import MuiDatePicker from "../../../components/basicComponent/MuiDatePicker";
import MuiSearchSelect from "../../../components/basicComponent/MuiSearchSelect";

const OfflineInventorySummary = () => {
  const flightData = [
    {
      sector: "Abbotsford–Toronto",
      departureDate: "01–December–2024",
      flightNo: "IX 157",
      departureTime: "12:00",
      arrivalTime: "23:05",
      totalSeats: 10,
      availableSeats: 10,
      holdSeats: 0,
      ticketCost: "500.00",
    },
    {
      sector: "Abbotsford–Toronto",
      departureDate: "02–December–2024",
      flightNo: "IX 157",
      departureTime: "12:00",
      arrivalTime: "23:05",
      totalSeats: 10,
      availableSeats: 10,
      holdSeats: 0,
      ticketCost: "500.00",
    },
    {
      sector: "Abbotsford–Toronto",
      departureDate: "03–December–2024",
      flightNo: "IX 157",
      departureTime: "12:00",
      arrivalTime: "23:05",
      totalSeats: 10,
      availableSeats: 10,
      holdSeats: 0,
      ticketCost: "500.00",
    },
    // Add more as needed
  ];

  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header text-center">
              <h3 className="card-title">Offline Inventory Summary</h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-custom">
                  <div className="card-body">
                    <div className="row mt-4">
                      <div className="col-md-4">
                        <MuiSearchSelect
                          placeholder={"Sector"}
                          label="Sector"
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4">
                        <MuiSearchSelect
                          placeholder={"Flight No"}
                          label="Flight No"
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "10px",
                          marginTop: "8px",
                        }}
                      >
                        <div className="user-button w-full">
                          <MuiButton
                            className="clear-btn "
                            label="Clear"
                            type="submit"
                          />
                          <MuiButton
                            label={"Get"}
                            className="main-btn get-btn"
                            variant="contained"
                            size="large"
                            type="submit"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="p-4">
                        <div className="mb-3">
                          <input
                            type="text"
                            className="form-control w-25"
                            placeholder="🔍 All Fields"
                          />
                        </div>

                        <div
                          className="table-container border rounded"
                          style={{ maxHeight: "400px", overflowY: "auto" }}
                        >
                          <table className="table table-bordered table-sm mb-0">
                            <thead
                              className="bg-dark text-white"
                              style={{ position: "sticky", top: 0, zIndex: 1 }}
                            >
                              <tr>
                                <th>Sector</th>
                                <th>Departure Date</th>
                                <th>Flight No</th>
                                <th>Departure Time</th>
                                <th>Arrival Time</th>
                                <th>Total Seats</th>
                                <th>Available Seats</th>
                                <th>Hold Seats</th>
                                <th>Ticket Cost</th>
                              </tr>
                            </thead>
                            <tbody>
                              {flightData.map((flight, index) => (
                                <tr
                                  key={index}
                                  className={
                                    index % 2 === 0 ? "bg-white" : "bg-light"
                                  }
                                >
                                  <td>{flight.sector}</td>
                                  <td>{flight.departureDate}</td>
                                  <td>{flight.flightNo}</td>
                                  <td>{flight.departureTime}</td>
                                  <td>{flight.arrivalTime}</td>
                                  <td>{flight.totalSeats}</td>
                                  <td>{flight.availableSeats}</td>
                                  <td>{flight.holdSeats}</td>
                                  <td>{flight.ticketCost}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                        <div
                          className="text-muted mt-2"
                          style={{ fontSize: "0.9rem" }}
                        >
                          Record ID: 0 &nbsp;&nbsp;&nbsp; 1–7 of 396
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default OfflineInventorySummary;
